<template>
  <div>
    <a-tabs :default-active-key="1" @change="callback">
      <a-tab-pane v-for="(item,index) in atabs" :key="index+1" :tab="item.name"></a-tab-pane>
    </a-tabs>
    <a-row :gutter="30">
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">猎企名称</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入猎企名称"
                v-model="params.enterprise"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">猎头姓名</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入信息"
                v-model="params.name"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8">
        <a-button
            type="primary"
            style="margin-right: 12px; padding: 0 30px"
            @click="getFilterData()"
        >筛选
        </a-button
        >
        <a-button style="margin-right: 12px" @click="resetParams"
        >重置
        </a-button
        >
      </a-col>
    </a-row>
    <a-row>
      <a-col span="18">
        <time-bar ref="timeTeam" :clean="clean" @change="onChangetime" @timeclean="timeclean"></time-bar>
      </a-col>
      <a-col span="2" style="text-align: center">
        <a-button type="primary">
          导出数据
        </a-button>
      </a-col>
    </a-row>
    <a-table style="margin-top: 20px"
             :pagination="pagination"
             :loading="loading"
             :columns="columns"
             :data-source="dataSource"
             rowKey="id"
             @change="getData">
      <template slot="CREATED" slot-scope="status, record">
        <span>{{ status.post_counts.CREATED ? status.post_counts.CREATED : 0 }}</span>
      </template>
      <template slot="AUDIT_PASSED" slot-scope="status, record">
        <span>{{ status.post_counts.AUDIT_PASSED ? status.post_counts.AUDIT_PASSED : 0 }}</span>
      </template>
      <template slot="INTERVIEW" slot-scope="status, record">
        <span>{{ status.post_counts.INTERVIEW ? status.post_counts.INTERVIEW : 0 }}</span>
      </template>
      <template slot="OFFERED" slot-scope="status, record">
        <span>{{ status.post_counts.OFFERED ? status.post_counts.OFFERED : 0 }}</span>
      </template>
      <template slot="ENTERED" slot-scope="status, record">
        <span>{{ status.post_counts.ENTERED ? status.post_counts.ENTERED : 0 }}</span>
      </template>
      <template slot="COMPLETED" slot-scope="status, record">
        <span>{{ status.post_counts.COMPLETED ? status.post_counts.COMPLETED : 0 }}</span>
      </template>
      <template slot="action" slot-scope="status, record">
        <a-button type="link" @click="GoDetails(record.id)">
          查看
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import Api from "@/api";
import TimeBar from "@/components/time-bar.component";

export default {
  name: "enterprise",
  components: {TimeBar},
  data() {
    return {
      clean: false,
      is_sign: 1,
      loading: false,
      dataSource: [],
      columns: [
        {
          title: '猎企名称',
          dataIndex: 'company',
          key: 'company',
          align: 'center'
        },
        {
          title: '签约猎头',
          dataIndex: 'sign_sub_count',
          key: 'sign_sub_count',
          align: 'center',
          width: 110
        },
        {
          title: '做单推荐',
          key: 'CREATED',
          scopedSlots: {customRender: 'CREATED'},
          align: 'center'
        },
        {
          title: '审核通过',
          key: 'AUDIT_PASSED',
          scopedSlots: {customRender: 'AUDIT_PASSED'},
          align: 'center'
        },
        {
          title: '一面数',
          scopedSlots: {customRender: 'INTERVIEW'},
          key: 'INTERVIEW',
          align: 'center'
        },
        {
          title: 'Offer数',
          scopedSlots: {customRender: 'OFFERED'},
          key: 'OFFERED',
          align: 'center'
        },
        {
          title: '入职数',
          scopedSlots: {customRender: 'ENTERED'},
          key: 'ENTERED',
          align: 'center'
        },
        {
          title: '过保数',
          scopedSlots: {customRender: 'COMPLETED'},
          key: 'COMPLETED',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {customRender: 'action'},
          align: 'center'
        },
        // {
        //   title: 'Tags',
        //   key: 'tags',
        //   dataIndex: 'tags',
        //   scopedSlots: { customRender: 'tags' },
        // },
        // {
        //   title: 'Action',
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      atabs: [
        {
          name: "已签约猎企"
        },
        {
          name: "待审核猎企"
        }
      ],
      params: {
        enterprise: "",
        name: "",
        time: [],
        timestring: [],
        date: "a"
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    timeclean(){
      this.clean = false;
    },
    GoDetails(id) {
      console.log(id);
      this.$router.push({
        path: "/hunter-enterprise-details",
        query: {
          user_id: id
        }
      })
    },
    onChangetime(a) {
      console.log(a.value)
      this.params.timestring = a.value
      this.getData();
    },
    callback(key) {
      if (key == 1) {
        this.is_sign = 1
      } else {
        this.is_sign = 0
      }
      let params = {};
      this.params = params;
      this.clean = true;
      console.log(key);
      this.getData();
    },
    getFilterData() {
      this.pagination.current = 1;
      this.getData(this.pagination);
    },
    async getData(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        is_sign: this.is_sign,
        time_start: this.params.timestring ? this.params.timestring[0] : null,
        time_end: this.params.timestring ? this.params.timestring[1] : null,
        name: this.params.name ? this.params.name : null,
        company_name: this.params.enterprise ? this.params.enterprise : null,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      };
      try {
        let response = await Api.hunter.enterprisecompany(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
        this.loading = false;
      } catch (e) {
      }
    },
    resetParams() {
      let params = {};
      this.params = params;
      this.clean = true;
      this.getData(this.pagination);
    },
  },
}
</script>

<style scoped>

</style>
